// extracted by mini-css-extract-plugin
export var closeButton = "_ov-2";
export var closeButtonIcon = "_ov-3";
export var lightboxContent = "_ov-1";
export var lightboxOverlay = "_ov-0";